import { render, staticRenderFns } from "./RemoveReportConfirmModal.vue?vue&type=template&id=223f2638&"
import script from "./RemoveReportConfirmModal.vue?vue&type=script&lang=js&"
export * from "./RemoveReportConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports